/**
 * Dohvaća rezultate pretrage privatnog smještaja za kartu.
 *
 * @param {string} resultsUrl - Url za dohvaćanje rezultata pretrage
 * @param {function} $ - jQuery
 * @constructor
 *
 * Rezultat {object[]} isporučuje se na uspijeh asinkronog dohvaćanja.
 * Čine ga elementi vrste a) ili b) (nisu isključivi).
 * a) facility
 * {
 *     id: {number},
 *     location: {latitude: {number}, longitude: {number}}
 * }
 * b) multiple facilities
 * {
 *     count: {number},
 *     southwesternmostCorner: {latitude: {number}, longitude: {number}},
 *     northeasternmostCorner: {latitude: {number}, longitude: {number}},
 *     location: {latitude: {number}, longitude: {number}}
 * }
 */
function ResultsProvider(resultsUrl, $) {
    validateType('string', resultsUrl);
    validateType('function', $);

    var self = this;
    var isResultsRequestAllowed = true;

    /**
     * @param {object} parameters
     * {
     *     filters: (serijalizirana #SearchPrivateFilterForm),
     *     northEast: { lat: {number}, lng: {number} },
     *     southWest: { lat: {number}, lng: {number} }
     * }
     * @returns {jqXHR|false}
     */
    self.findResultsAsyncIfAllowed = function (parameters) {
        return isResultsRequestAllowed ? self.findResultsAsync(parameters) : false;
    };

    /**
     * @param {object} parameters
     * {
     *     filters: (serijalizirana #SearchPrivateFilterForm),
     *     northEast: { lat: {number}, lng: {number} },
     *     southWest: { lat: {number}, lng: {number} }
     * }
     * @returns {jqXHR}
     */
    self.findResultsAsync = function (parameters) {
        return $.ajax({
            type: 'POST', // ne možemo raditi GET ajax request s partnerskih servisa
            url: resultsUrl,
            data: parameters,
            // Ne želimo s ovim pozivom aktivirati globalni ajaxSuccess event jer smo na njega u frame servisu stavili
            // handler koji automatski vraća korisnika na vrh stranice. Ovo je privremeno rješenje, ispravan način je da
            // se na ajax pozive za koje želimo u frame-u korisnika vratiti na vrh stranice ručno lansira i prati custom
            // event (npr. adriatic.frame.pagerefreshed).
            global: false
        });
    };

    self.forbidResultsRequest = function () {
        isResultsRequestAllowed = false;
    };

    /**
     * @param {number} miliseconds
     */
    self.allowResultsRequestAfter = function (miliseconds) {
        if (!miliseconds) {
            isResultsRequestAllowed = true;
            return;
        }

        setTimeout(function () {
            isResultsRequestAllowed = true;
        }, miliseconds);
    };

    function validateType(expected, actual) {
        for (var i = 1; i < arguments.length; i++) {
            if (typeof arguments[i] !== expected) {
                throw new TypeError('expected a ' + expected + ', got ' + typeof arguments[i]);
            }
        }
    }
}

ResultsProvider.prototype = {};

export default ResultsProvider;
